<div id="whyPostex" class="whypostexWrap">
    <div class="">
        <h3 class="text-white text-[37px] font-bold text-center leading-[46px]">
            Why PostEx<span class="text-[#92cf4f]">.</span>
        </h3>
        <div class="grapWrap">
            <div class="statusContent ">
                <div class="order-last md:order-first  md:max-w-[316px] contentWrap flex flex-row md:flex-col gap-3 item-center justify-center ">
                    <h3> PKR 25B+ </h3>
                    <p> Value of upfront payments made </p>
                </div>
                <div class="contentWrap w-[50%] md:max-w-[316px] flex flex-col gap-3 item-center justify-center">
                    <h3>25,000+ </h3>
                    <p> Happy & Growing merchants </p>
                </div>
                <div class="flex flex-col gap-3 item-center justify-center  order-first w-[50%] md:order-last md:max-w-[316px] contentWrap">
                    <h3> 92% </h3>
                    <p> Delivery Success Rate </p>
                </div>
            </div>
            <div class="radialGraph  flex items-center flex-col justify-center">
                <canvas class="self-center"  width="246px" height="246px" class="black-circle" id="pie-chart"></canvas>
                <div class="transaction-label text-center mt-8 ">Logistic Market Share</div>

                <!-- <img src="assets/images/Cod/radialGraph.png" alt=""> -->
            </div>
            <div class="lineGraph flex items-center flex-col justify-center">
                <div>
                    <!-- <div class="transaction-label h-10 text-center -rotate-90">Amounts</div> -->
                    <canvas *ngIf="showAreaChart" width="400px" height="250px" id="line-chart"></canvas>
                </div>
                <div class="transaction-label text-center mt-8">Growth</div>
                <!-- <img src="assets/images/Cod/lineGraph.png" alt=""> -->
            </div>
        </div>
    </div>
</div>